@if (VendorId) {
  <div class="container-fluid h-100 d-flex flex-column">
    <!-- VPDW-4240: the information renewal is vendor-level — one date shared by
         every client below — so it belongs here once rather than as a column
         repeating the same value down the grid, which would invite reading it as
         per-client. The grid's own renewal column is the PAYMENT one, which does
         vary by relationship. -->
    @if (InfoRenewalDueDate) {
      <div class="row pb-3 info-renewal-row">
        <div class="col">
          <app-display-card>
            <dl class="vendor-info-renewal">
              <div class="vendor-info-renewal__row">
                <dt>Information renewal</dt>
                <dd>
                  <span class="vendor-info-renewal__date">
                    {{ InfoRenewalDueDate | date: 'MM/dd/y' }}
                  </span>
                  <span class="vendor-info-renewal__chip"
                    >Vendor-wide · all clients</span
                  >
                  @if (!LastInfoRenewalDate) {
                    <span class="vendor-info-renewal__chip"
                      >From signup date</span
                    >
                  }
                  @if (InfoRenewalChipLabel) {
                    <span class="chip" [class]="InfoRenewalChipClass">
                      {{ InfoRenewalChipLabel }}
                    </span>
                  }
                </dd>
              </div>
              <div class="vendor-info-renewal__row">
                <dt>Last completed</dt>
                <dd>
                  <span class="vendor-info-renewal__date">
                    {{ (LastInfoRenewalDate | date: 'MM/dd/y') || '—' }}
                  </span>
                </dd>
              </div>
            </dl>
          </app-display-card>
        </div>
      </div>
    }
    <div class="row pb-4 flex-grow-1">
      <div class="col">
        <app-company-vendors-grid
          [gridName]="'VendorClients'"
          [suppliedQueryData]="SuppliedQueryData"
          [ColumnIdToColumnActions]="ColumnIdToColumnActions"
          (actionEvent)="onActionEvent($event)"
        ></app-company-vendors-grid>
      </div>
    </div>
  </div>
}
